import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router';
import { AuthProvider, ProtectedRoute } from './contexts/AuthContext';
import { PermissionProvider } from './contexts/PermissionContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { MasterDataProvider } from './contexts/MasterDataContext';
import { EntitySettingsProvider } from './contexts/EntitySettingsContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import TopBarLoader from './components/common/TopBarLoader';
import LegacyApp from './LegacyApp';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';
import RoleLayout from './views/RoleLayout';
import SuperAdminLogin from './pages/superadmin/SuperAdminLogin';
import Layout7 from './views/application7/Layout7';
import SetPasswordPage from './pages/SetPasswordPage';
import PlaybookPage from './pages/PlaybookPage';

const AppRouter: React.FC = () => (
  <ErrorBoundary>
    <ThemeProvider>
      <AuthProvider>
        <MasterDataProvider>
          <Router>
            <TopBarLoader />
            <Routes>
              <Route path="/login"             element={<LoginPage />} />
              <Route path="/super-admin/login" element={<SuperAdminLogin />} />
              <Route path="/set-password"      element={<SetPasswordPage />} />
              <Route path="/super-admin/*"     element={<Layout7 />} />
              <Route path="/admin"             element={<ProtectedRoute fallback={<Navigate to="/login" replace />}><AdminPage /></ProtectedRoute>} />
              <Route path="/legacy/*"          element={<LegacyApp />} />
              <Route path="/playbook"          element={<ProtectedRoute fallback={<Navigate to="/login" replace />}><PlaybookPage /></ProtectedRoute>} />
              <Route path="/*"                 element={<ProtectedRoute fallback={<Navigate to="/login" replace />}><PermissionProvider><EntitySettingsProvider><ErrorBoundary><RoleLayout /></ErrorBoundary></EntitySettingsProvider></PermissionProvider></ProtectedRoute>} />
            </Routes>
          </Router>
        </MasterDataProvider>
      </AuthProvider>
    </ThemeProvider>
  </ErrorBoundary>
);

export default AppRouter;
